var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "_flex _px-2 _py-3 _jc-sb _ai-c _bxsh--base" },
    [
      _c("div", [_vm._t("default")], 2),
      _vm._v(" "),
      _c(
        "icon-link",
        {
          staticClass: "_tc--accent",
          attrs: { icon: "times", as: "button" },
          on: { click: _vm.onClose },
        },
        [_vm._v(_vm._s(_vm.Resources.Common.ModalCloseButton))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }